// Copyright (c) 2016 Deere & Company

import DealerSearch from './components/dealer-search';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {validateDealerSearchCriteria} from './service/search-params';

const getStateToBindToContainerProps = state => ({
    ...state.productDealerSearch,
    isDealerSearchValid: validateDealerSearchCriteria(state.productDealerSearch.searchParams),
    isModalVisible: state.createTransfer.dealerSearchModal.isVisible,
    isSapUp: state.app.sapStatus.isSapUp
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {children} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        children
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DealerSearch);



// WEBPACK FOOTER //
// ./src/product/dealer-search/state-connector.js